/* eslint-disable @typescript-eslint/naming-convention */
export const pixelateBlockType = "PixelateBlock";
export const blackAndWhiteBlockType = "BlackAndWhiteBlock";
export const exposureBlockType = "ExposureBlock";
export const contrastBlockType = "ContrastBlock";
export const desaturateBlockType = "DesaturateBlock";
export const posterizeBlockType = "PosterizeBlock";
export const kaleidoscopeBlockType = "KaleidoscopeBlock";
export const greenScreenBlockType = "GreenScreenBlock";
export const glassBlockType = "GlassBlock";
export const frameBlockType = "FrameBlock";
export const blurBlockType = "BlurBlock";
export const directionalBlurBlockType = "DirectionalBlurBlock";
export const compositionBlockType = "CompositionBlock";
export const glitchBlockType = "GlitchBlock";
export const tileBlockType = "TileBlock";
export const wipeBlockType = "WipeBlock";
export const maskBlockType = "MaskBlock";
export const particleBlockType = "ParticleBlock";
export const spritesheetBlockType = "SpritesheetBlock";
export const tintBlockType = "TintBlock";
export const premultiplyAlphaBlockType = "PremultiplyAlphaBlock";
/* eslint-enable @typescript-eslint/naming-convention */
//# sourceMappingURL=blockTypes.js.map